import SiteNavbar from '@/components/feature/SiteNavbar';
import SiteFooter from '@/components/feature/SiteFooter';
import Hero from './components/Hero';
import WhatIs from './components/WhatIs';
import Formula from './components/Formula';
import HowWeCreate from './components/HowWeCreate';
import Characters from './components/Characters';
import FlavorMap from './components/FlavorMap';
import Stories from './components/Stories';
import WhyNomoism from './components/WhyNomoism';
import ContactSection from './components/ContactSection';
import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function Home() {
  useScrollReveal();

  return (
    <div className="min-h-screen w-full bg-background-50">
      <SiteNavbar />
      <main>
        <Hero />
        <WhatIs />
        <Formula />
        <HowWeCreate />
        <Characters />
        <FlavorMap />
        <Stories />
        <WhyNomoism />
        <ContactSection />
      </main>
      <SiteFooter />
    </div>
  );
}